<script>
import SortableList from './sortable-list'
import SortableItem from './sortable-item'
import { mapActions } from 'vuex'

export default {
  name: 'CategoriesInputs',
  components: {
    SortableItem,
    SortableList,
  },
  props: {
    groupIndex: {
      type: Number,
      default: null,
    },
    tierIndex: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [{
        name: '',
      }],
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      categories: [{ name: '' }],
    }
  },
  computed: {
    propPrefix() {
      let prefix = ''
      if (typeof this.groupIndex === 'number') prefix = prefix + `[${this.groupIndex}].items`
      if (typeof this.tierIndex === 'number') prefix = prefix + `[${this.tierIndex}].items`
      return prefix
    },
  },
  watch: {
    value: {
      handler(val) {
        this.categories = val
      },
      deep: true,
    },
  },
  mounted() {
    this.categories = this.value
  },
  methods: {
    ...mapActions('category', ['addItem', 'removeItem', 'sortItem']),
    sortEnd({ oldIndex, newIndex }) {
      this.sortItem({
        oldIndex,
        newIndex,
        groupIndex: this.groupIndex,
        tierIndex: this.tierIndex,
      })
    },
  },
}
</script>

<template>
  <div :class="$style.categories">
    <div
      :class="$style.add"
    >
      <div
        v-if="!viewMode"
        @mousedown.stop=""
        @click="addItem({itemType: 'category', groupIndex, tierIndex })"
      >
        + Add Category
      </div>
    </div>
    <div :class="[$style.bracket, {[$style.singleItem] : categories.length === 1}]" />
    <sortable-list
      v-model="categories"
      :class="$style.inputs"
      :disabled="viewMode"
      @sort-end="sortEnd"
    >
      <sortable-item
        v-for="(category, index) in categories"
        :key="index"
        :index="index"
        :disabled="viewMode"
        :class="$style.input"
      >
        <el-form-item
          :class="$style.formItem"
          :prop="`tree${propPrefix}[${index}].name`"
        >
          <el-input
            v-model="category.name"
            :class="{[$style.disabledInput]: viewMode}"
            :disabled="viewMode"
          />
          <template v-if="categories.length > 1 && !viewMode">
            <i :class="['el-icon-d-caret', $style.icon, $style.iconDrag]" />
            <i
              :class="['el-icon-delete', $style.icon, $style.iconDel]"
              @mousedown.stop=""
              @click="removeItem({groupIndex, tierIndex, index})"
            />
          </template>
        </el-form-item>
      </sortable-item>
    </sortable-list>
  </div>
</template>

<style lang="scss" module>
.categories {
  display: grid;
  grid-template-areas:
    "add add"
    "brackets inputs";
  grid-template-rows: auto 1fr;
  grid-template-columns: 30px 200px;
  grid-column-gap: 10px;
  width: 240px;
}

.categories + .categories {
  margin-top: rem(16px);
}

.add {
  grid-area: add;
  min-height: rem(18px);
  margin-bottom: rem(8px);
  font-weight: bold;
  color: var(--color-primary);
  text-align: right;

  div {
    cursor: pointer;
  }
}

.bracket {
  grid-area: brackets;
  margin: rem(20px 0 44px);
  border: 1px solid var(--color-dark-gray);
  border-right-width: 0;
}

.singleItem {
  border-bottom-width: 0;
}

.inputs {
  display: flex;
  flex-direction: column;
  grid-area: inputs;
  justify-content: space-between;
}

.formItem {
  margin: 0;
}

.input {
  position: relative;
  margin-bottom: rem(24px);

  :global {
    .is-error .el-form-item__content{
      flex-direction: column;
      // min-height: 3rem;
    }

    .el-form-item__error {
      // display: none;
    }
  }
}

.disabledInput {
  :global {
    .el-input__inner {
      color: var(--color-text) !important;
    }
  }
}

.icon {
  position: absolute;
  top: 1.25rem;
  right: 0;
  color: var(--color-primary);
  cursor: pointer;
  transform: translateY(-50%);
}

.iconDel {
  right: rem(6px);
}

.iconDrag {
  right: rem(24px);
}
</style>
